import { render, staticRenderFns } from "./PsEventPricing.vue?vue&type=template&id=3846036c&scoped=true&"
import script from "./PsEventPricing.vue?vue&type=script&lang=js&"
export * from "./PsEventPricing.vue?vue&type=script&lang=js&"
import style0 from "./PsEventPricing.vue?vue&type=style&index=0&id=3846036c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846036c",
  null
  
)

export default component.exports